import { useState, useMemo } from "react";
import { toast } from "react-toastify";

import Button from "components/v1/Button";
import TableBuyer from "components/molecules/buyer-match/table-buyer";
import ModalCreateBuyerAgent from "components/molecules/buyer-match/modal-create-buyer-agent";
import ModalKonfirmasi from "components/molecules/buyer-match/modal-konfirmasi";

// Assets
import IPlus from "assets/i-plus.js";
import IArchived from "assets/i-archived.js";
import IMagnifier from "assets/i-magnifier.js";

// Ctx
import { useBuyerMatchCtx } from "contexts/buyer-match";
import { useCreateCustomer } from "api/buyer-match/mutation";
import { useDebounce } from "hooks/useDebounce";

const ListBuyer = () => {
  const { mutate: createCustomerMutation } = useCreateCustomer();

  const [submitData, setSubmitData] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(""); // "create" | "confirm"
  const [search, setSearch] = useState("");

  const {
    listCustomer,
    isLoadingListCustomer,
    listPropertyCategories,
    refetchListCustomer,
    setIsOpenDetailBuyer,
    setSelectedLeadId,
    setListCustomerParams,
    listCustomerParams,
    countData,
    totalPage,
  } = useBuyerMatchCtx();

  const CategoryOptions = useMemo(() => {
    return listPropertyCategories?.data?.data?.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }, [listPropertyCategories]);

  const onCloseModal = () => {
    setIsOpenModal("");
    setSubmitData(null);
  };

  const onSubmitModalCreateBuyerAgent = () => {
    const customer = submitData;

    if(!customer.min_building_area) {
      customer.min_building_area = 0;
    }

    if(!customer.min_surface_area) {
      customer.min_surface_area = 0;
    }
    
    if(!customer.bedroom) {
      customer.bedroom = 0;
    }

    if(!customer.bathroom) {
      customer.bathroom = 0;
    }

    customer.whatsapp_number = customer.dial_code + customer.whatsapp_number;

    const data = { customer };

    createCustomerMutation(
      { data },
      {
        onSuccess: () => {
          toast.success("Profil Customer berhasil dibuat");
          refetchListCustomer();
        },
        onError: (error) => {
          toast.error(
            error?.response?.data?.message ?? "Gagal membuat profil customer"
          );
        },
        onSettled: () => {
          onCloseModal();
        },
      }
    );
  };

  const { debounceFn } = useDebounce({
    onChange: (query) => {
      setListCustomerParams({
        ...listCustomerParams,
        q: query,
      });
    },
    delay: 500,
  });

  return (
    <>
      <div className="min-h-[calc(100vh-81px-73px-48px)] p-4 rounded-[4px] bg-white">
        <div className="flex items-center justify-between mb-2">
          <h3>Daftar Customer</h3>

          <div className="flex items-center justify-between gap-[12px]">
            <div className="h-[32px] p-2 flex justify-center items-center gap-1 rounded-[4px] border-[1px] border-solid border-[#D8D8D9]">
              <IMagnifier />
              <input
                className="h-[24px] py-2 text-[11px] leading-[17px] tracking-[-0.4px] font-inter text-[#252526] placeholder:text-[#808285]"
                placeholder="Cari customer berdasarkan nama"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  debounceFn(e.target.value);
                }}
              />
            </div>
            <Button
              icon={IPlus}
              text="Buat Profil Customer"
              variant="primary"
              onClick={() => setIsOpenModal("create")}
              disabled={listCustomer?.data?.data?.length >= 10}
            />
            <a href="/buyer-match/list-archived">
              <Button
                icon={IArchived}
                iconColor="#252526"
                text="Arsip"
                type="secondary"
              />
            </a>
          </div>
        </div>

        <div className="overflow-x-auto">
          <TableBuyer
            data={listCustomer?.data?.data ?? []}
            isLoading={isLoadingListCustomer}
            handleOpenModal={(id) => {
              setSelectedLeadId(id);
              setIsOpenDetailBuyer(true);
            }}
            setListCustomerParams={setListCustomerParams}
            listCustomerParams={listCustomerParams}
            isSearch={!!search}
            countData={countData}
            totalPage={totalPage}
          />
        </div>
      </div>

      <ModalCreateBuyerAgent
        options={CategoryOptions}
        isOpen={isOpenModal === "create"}
        onClose={onCloseModal}
        onSubmit={(data) => {
          setSubmitData(data);
          setIsOpenModal("confirm");
        }}
      />
      <ModalKonfirmasi
        isOpen={isOpenModal === "confirm"}
        onClose={onCloseModal}
        title="Buat Profil Customer?"
        description="Profil customer akan dibuat sesuai data yang sudah kamu isi."
        leftBtnText="Kembali"
        rightBtnText="Buat Profil Customer"
        leftBtnAction={onCloseModal}
        rightBtnAction={onSubmitModalCreateBuyerAgent}
      />
    </>
  );
};

export default ListBuyer;
